import { string, struct } from 'io-ts/lib/Decoder';

/**
 * BE → UI: prompt for a single frame with a junction discrepancy
 */
export const LengthCorrectionPrompt = struct({
	frameId: string,
});
